import moment from 'moment';
// TODO Future: refactor can be necessary
export default {
  data() {
    return {
      time: 0,
      countdownTimer: null,
    };
  },
  computed: {
    getTimer() {
      if (this.time === 0) {
        return null;
      }
      return moment().startOf('day').seconds(this.time).format('mm:ss');
    },
  },
  methods: {
    setTimer(time) {
      if (this.countdownTimer) {
        console.log(this.countdownTimer, 'reset');
        this.resetTimer();
      }
      this.time = time;
      this.countdownTimer = setInterval(() => {
        if (this.time === 0) {
          clearInterval(this.countdownTimer);
        } else {
          this.time--;
        }
      }, 1000);
    },
    resetTimer() {
      this.time = 0;
      clearInterval(this.countdownTimer);
    },
  },
};
